export { default as ClientMetrics } from './lib/client-metrics.js';
